var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.numbers)?_c('div',{staticClass:"pcso-ball-cont"},_vm._l((_vm.combination),function(num,i){return _c('v-avatar',{key:i,staticClass:"pcso-ball mr-1 mb-1 body-2",class:_vm.color(num),attrs:{"size":"25"}},[_vm._v(_vm._s(num))])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }